import {useGoVehisService} from "../../../utils/axios";
import React, {useEffect, useMemo, useState} from "react";
import {
  Box,
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  FormControlLabel,
  IconButton,
  MenuItem,
  Select,
  Table,
  TableBody,
  TableSortLabel,
  TextField,
  Tooltip
} from '@material-ui/core';
import WarningIcon from '@material-ui/icons/Warning';
import AddIcon from '@material-ui/icons/Add';
import SaveIcon from '@material-ui/icons/Save';
import TableRow from "@material-ui/core/TableRow";
import TableHead from "@material-ui/core/TableHead";
import TableCell from "@material-ui/core/TableCell";
import "./AttributesList.css";
import DeleteIcon from "@material-ui/icons/Delete";
import Checkbox from "@material-ui/core/Checkbox";
import EditIcon from "@material-ui/icons/Edit";
import CopyIcon from "@material-ui/icons/FileCopy";
import TableContainer from "@material-ui/core/TableContainer";
import Typography from '@material-ui/core/Typography';
import VisibilityIcon from '@material-ui/icons/Visibility';
import FileUploadIcon from '@material-ui/icons/CloudUpload';
import { DropzoneArea } from 'material-ui-dropzone';

const classList = [
  "Lekkie dostawcze",
  "Mikro",
  "Małe",
  "Luksusowe",
  "Executive",
  "Wyższa średnia",
  "Niższa średnia",
  "Średnie dostawcze",
  "Ciężkie dostawcze"
]

const segmentList = [
  "Duże dostawcze",
  "Kombivany",
  "Kompaktowe / średnie",
  "Limuzyny / duże",
  "Luksusowe",
  "Małe dostawcze",
  "Miejskie / małe",
  "Pick-up",
  "Sportowe",
  "SUVy / terenowe duże",
  "SUVy / terenowe małe",
  "SUVy / terenowe średnie",
  "Średnie dostawcze",
  "Vany duże / minibusy",
  "Vany średnie"
]

const typeList = [
  "DOSTAWCZE",
  "OSOBOWE"
]

const internalBodyTypeList = [
  "Autolaweta",
  "Chłodnia/Izoterma",
  "Coupe / Roadster",
  "Do Zabudowy",
  "Doka",
  "Furgon",
  "Hatchback",
  "Inne",
  "Kabriolet",
  "Kamper",
  "Kombi",
  "Kontener",
  "Osobowy",
  "Pick-Up",
  "Podnośnik",
  "Sedan",
  "Skrzynia",
  "Skrzynia z plandeką",
  "Skrzynia z wywrotką",
  "SUV / Crossover",
  "VAN / Bus"
]

const initFilter = {
  id: "",
  brand: "",
  model: "",
  modelCode: "",
  bodyType: "",
  classType: "",
  segment: "",
  type: "",
  premium: "",
  internalBodyType: "",
  defaultDescription: "",
  onlyDuplicates: false
}

const textFilterKeys = ["id", "model", "modelCode", "bodyType", "defaultDescription"];
const exactFilterKeys = ["brand", "classType", "segment", "type", "internalBodyType"];

// Normalizacja do porównań: bez rozróżniania wielkości liter i nadmiarowych spacji.
const norm = (v) => (v === null || v === undefined ? "" : String(v)).trim().replace(/\s+/g, " ").toLowerCase();

const compareText = (a, b) =>
  String(a === null || a === undefined ? "" : a)
    .localeCompare(String(b === null || b === undefined ? "" : b), "pl", {sensitivity: "base", numeric: true});

// Zwraca klucze, które występują w więcej niż jednej pisowni (różnią się tylko wielkością liter/spacjami).
const findSpellingVariants = (items, keyFn, valueFn) => {
  const groups = new Map();
  items.forEach(el => {
    const value = valueFn(el);
    if (!norm(value)) return;
    const key = keyFn(el);
    if (!groups.has(key)) groups.set(key, new Set());
    groups.get(key).add(String(value).trim());
  });
  const result = new Map();
  groups.forEach((values, key) => {
    if (values.size > 1) result.set(key, Array.from(values));
  });
  return result;
};

function AttributesList() {
  const goVehisService = useGoVehisService();

  const [attributesElements, setAttributeElements] = useState([]);
  const [createdIndex, setCreatedIndex] = useState(-1);
  const [filter, setFilter] = useState(initFilter);
  const [sort, setSort] = useState({key: null, dir: "asc"});

  useEffect(() => {
    goVehisService.get("/admin/config/attributes").then(
      res => {setAttributeElements(res.data);}
    )
  }, [])

  const addRow = () => {
    let index = createdIndex;
    setCreatedIndex(createdIndex - 1);
    let newElement = {
      id: index,
      brand: "",
      model: "",
      modelCode: "",
      bodyType: "",
      classType: "",
      segment: "",
      type: "",
      premium: false,
      length: null,
      width: null,
      height: null,
      trunkCapacity: null,
      internalBodyType: "",
      defaultDescription: "",
      deleted: false,
      edited: false,
      created: true
    }
    setAttributeElements([newElement, ...attributesElements]);
  }

  const copyRow = (row) => {
    let index = createdIndex;
    setCreatedIndex(createdIndex - 1);
    let newElement = {
      id: index,
      brand: row.brand,
      model: row.model,
      modelCode: row.modelCode,
      bodyType: row.bodyType,
      classType: row.classType,
      segment: row.segment,
      type: row.type,
      premium: row.premium,
      length: row.length,
      width: row.width,
      height: row.height,
      trunkCapacity: row.trunkCapacity,
      internalBodyType: row.internalBodyType,
      defaultDescription: row.defaultDescription,
      deleted: false,
      edited: false,
      created: true
    }
    setAttributeElements([newElement, ...attributesElements]);
  }

  const handleChange = (e, id, fieldName) => {
    const newAttributesElements = [...attributesElements];
    let index = attributesElements.findIndex(el => el.id === id);
    switch(fieldName) {
      case "brand": newAttributesElements[index].brand = e.target.value; break;
      case "model": newAttributesElements[index].model = e.target.value; break;
      case "modelCode": newAttributesElements[index].modelCode = e.target.value; break;
      case "bodyType": newAttributesElements[index].bodyType = e.target.value; break;
      case "classType": newAttributesElements[index].classType = e.target.value; break;
      case "segment": newAttributesElements[index].segment = e.target.value; break;
      case "type": newAttributesElements[index].type = e.target.value; break;
      case "premium": newAttributesElements[index].premium = e.target.checked; break;
      case "length": newAttributesElements[index].length = e.target.value; break;
      case "width": newAttributesElements[index].width = e.target.value; break;
      case "height": newAttributesElements[index].height = e.target.value; break;
      case "trunkCapacity": newAttributesElements[index].trunkCapacity = e.target.value; break;
      case "internalBodyType": newAttributesElements[index].internalBodyType = e.target.value; break;
      case "defaultDescription": newAttributesElements[index].defaultDescription = e.target.value; break;
    }
    setAttributeElements(newAttributesElements);
    // console.log(attributesElements);
  };

  const handleChangeFilter = (e, fieldName) => {
    const value = fieldName === "onlyDuplicates" ? e.target.checked : e.target.value;
    setFilter(prev => ({...prev, [fieldName]: value}));
  }

  const handleSort = (key) => {
    setSort(prev => prev.key === key
      ? {key, dir: prev.dir === "asc" ? "desc" : "asc"}
      : {key, dir: "asc"});
  }

  // Wpisy różniące się wyłącznie wielkością liter (marka, model, typ nadwozia) oraz zdublowane wiersze.
  const duplicateInfo = useMemo(() => {
    const active = attributesElements.filter(el => !el.deleted);
    const brandKey = el => norm(el.brand);
    const modelKey = el => norm(el.brand) + "|" + norm(el.model);
    const brandVariants = findSpellingVariants(active, brandKey, el => el.brand);
    const modelVariants = findSpellingVariants(active, modelKey, el => el.model);
    const bodyVariants = findSpellingVariants(active, el => norm(el.bodyType), el => el.bodyType);
    const rowKey = el => [el.brand, el.model, el.modelCode, el.bodyType].map(norm).join("|");
    const rowCounts = new Map();
    active.forEach(el => rowCounts.set(rowKey(el), (rowCounts.get(rowKey(el)) || 0) + 1));

    const issuesById = new Map();
    active.forEach(el => {
      const issues = [];
      if (brandVariants.has(brandKey(el))) {
        issues.push("Marka w kilku pisowniach: " + brandVariants.get(brandKey(el)).join(" / "));
      }
      if (modelVariants.has(modelKey(el))) {
        issues.push("Model w kilku pisowniach: " + modelVariants.get(modelKey(el)).join(" / "));
      }
      if (bodyVariants.has(norm(el.bodyType))) {
        issues.push("Typ nadwozia w kilku pisowniach: " + bodyVariants.get(norm(el.bodyType)).join(" / "));
      }
      if (rowCounts.get(rowKey(el)) > 1) {
        issues.push("Zduplikowany wiersz (marka, model, model_code, nadwozie bez względu na wielkość liter)");
      }
      if (issues.length) issuesById.set(el.id, issues);
    });
    return {issuesById};
  }, [attributesElements]);

  const brandOptions = useMemo(() => {
    const byNorm = new Map();
    attributesElements.forEach(el => {
      const n = norm(el.brand);
      if (n && !byNorm.has(n)) byNorm.set(n, String(el.brand).trim());
    });
    return Array.from(byNorm.values()).sort(compareText);
  }, [attributesElements]);

  const visibleElements = useMemo(() => {
    let list = attributesElements.filter(el => {
      // wiersze dodawane/edytowane nie znikają po zmianie filtra
      if (el.created || el.edited) return true;
      if (textFilterKeys.some(k => filter[k] && !norm(el[k]).includes(norm(filter[k])))) return false;
      if (exactFilterKeys.some(k => filter[k] && norm(el[k]) !== norm(filter[k]))) return false;
      if (filter.premium && (filter.premium === "yes") !== !!el.premium) return false;
      if (filter.onlyDuplicates && !duplicateInfo.issuesById.has(el.id)) return false;
      return true;
    });
    if (sort.key) {
      const factor = sort.dir === "asc" ? 1 : -1;
      list = [...list].sort((a, b) =>
        sort.key === "id" ? factor * (a.id - b.id) : factor * compareText(a[sort.key], b[sort.key]));
    }
    return list;
  }, [attributesElements, filter, sort, duplicateInfo]);

  // Komórka nagłówka: etykieta z sortowaniem + filtr (tekstowy lub lista) pod spodem.
  // options: undefined -> pole tekstowe, tablica -> lista wyboru ({value, label} lub string).
  const headerCell = (key, label, {sortable = true, options, minWidth} = {}) => {
    const hasFilter = key in filter;
    const opts = options && options.map(o => typeof o === "string" ? {value: o, label: o} : o);
    return (
      <TableCell className="attr-head-cell" sortDirection={sortable && sort.key === key ? sort.dir : false} style={{minWidth}}>
        {sortable
          ? <TableSortLabel active={sort.key === key} direction={sort.key === key ? sort.dir : "asc"} onClick={() => handleSort(key)}>
              {label}
            </TableSortLabel>
          : <span>{label}</span>}
        {hasFilter && (opts
          ? <Select
              displayEmpty
              value={filter[key]}
              onChange={e => handleChangeFilter(e, key)}
              className="attr-filter"
              variant="outlined"
              margin="dense"
              fullWidth
            >
              <MenuItem value="">Wszystko</MenuItem>
              {opts.map(o => <MenuItem key={o.value} value={o.value}>{o.label}</MenuItem>)}
            </Select>
          : <TextField
              value={filter[key]}
              onChange={e => handleChangeFilter(e, key)}
              className="attr-filter"
              placeholder="Filtruj"
              variant="outlined"
              margin="dense"
              fullWidth
            />)}
      </TableCell>
    );
  };

  const activeFilterCount = Object.keys(filter).filter(k => filter[k] && filter[k] !== false).length;

  const deleteRow = (id) => {
    const newAttributesElements = [...attributesElements];
    let index = attributesElements.findIndex(el => el.id === id);
    if(newAttributesElements[index].created) {
      newAttributesElements.splice(index, 1);
    } else {
      newAttributesElements[index].deleted = !newAttributesElements[index].deleted;
    }
    setAttributeElements(newAttributesElements);
  }

  const editRow = (id) => {
    const newAttributesElements = [...attributesElements];
    let index = attributesElements.findIndex(el => el.id === id);
    newAttributesElements[index].edited = true;
    setAttributeElements(newAttributesElements);
  }

  const calculateColor = (el) => {
    if(el.deleted) {
      return "#ffb7b7";
    } else if(el.created) {
      return "#e3ffe3";
    } else if(el.edited) {
      return "#fffad2";
    }
    return "transparent";
  }

  const sendChanges = () => {
    const list = [...attributesElements];
    const changedElements = list.filter(el => el.edited && !el.deleted).map(toCleanObject);
    const createdELements = list.filter(el => el.created).map(toCleanObject);
    const deletedIds = list.filter(el => el.deleted).map(el => el.id);
    const touchedWithIssues = list.filter(el =>
      (el.created || el.edited) && !el.deleted && duplicateInfo.issuesById.has(el.id));
    if (touchedWithIssues.length > 0 && !window.confirm(
      `Wykryto ${touchedWithIssues.length} dodanych/zmienionych wierszy różniących się od istniejących tylko wielkością liter lub zduplikowanych. Zapisać mimo to?`)) {
      return;
    }
    const allData = {
      createdList: createdELements,
      updatedList: changedElements,
      deletedIds: deletedIds
    };
    goVehisService.post("/admin/config/attributes", allData).then(r => location.reload())
  }

  const toCleanObject = (el) => {
    return {
      id: el.id,
      brand: el.brand,
      model: el.model,
      modelCode: el.modelCode,
      bodyType: el.bodyType,
      classType: el.classType,
      segment: el.segment,
      type: el.type,
      premium: el.premium,
      length: el.length,
      width: el.width,
      height: el.height,
      trunkCapacity: el.trunkCapacity,
      internalBodyType: el.internalBodyType,
      defaultDescription: el.defaultDescription
    }

  }

  const [openImagePreview, setOpenImagePreview] = useState(false)
  const [openImageUpload, setOpenImageUpload] = useState(false)
  const [imagePreview, setImagePreview] = useState(null)
  const [idForImage, setIdForImage] = useState(null)
  const [uploadedImage, setUploadedImage] = useState(null)

  const handleUpload = () => {

    const formData = new FormData();
    formData.append("file", uploadedImage);

    goVehisService
      .post(`/admin/config/attributes/${idForImage}/upload`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then((response) => {
        const newAttributesElements = [...attributesElements];
        const index = attributesElements.findIndex(el => el.id === idForImage);
        if (index !== -1) {
          newAttributesElements[index].url = response.data;
          setAttributeElements(newAttributesElements);
        }
      })
      .catch((error) => {
        alert("Failed to upload image.");
      })
      .finally(() => {
        setOpenImageUpload(false);
      });
  };


  return (
    <div>
      <Box className="attr-toolbar">
        <Box className="attr-toolbar-left">
          <Button onClick={e => addRow()} variant="contained" color="primary" startIcon={<AddIcon/>} disableElevation>Dodaj wiersz</Button>
          <Button onClick={e => sendChanges()} variant="contained" color="secondary" startIcon={<SaveIcon/>} disableElevation>Zapisz zmiany</Button>
        </Box>
        <Box className="attr-toolbar-right">
          <FormControlLabel
            control={<Checkbox size="small" checked={filter.onlyDuplicates} onChange={e => handleChangeFilter(e, "onlyDuplicates")}/>}
            label={`Tylko podejrzane duplikaty (${duplicateInfo.issuesById.size})`}
          />
          <Button onClick={() => setFilter(initFilter)} variant="outlined" size="small" disabled={activeFilterCount === 0}>
            Wyczyść filtry{activeFilterCount > 0 ? ` (${activeFilterCount})` : ""}
          </Button>
          <Typography variant="body2" color="textSecondary">
            Wyświetlono <b>{visibleElements.length}</b> z {attributesElements.length}
          </Typography>
        </Box>
      </Box>
      <TableContainer className="attributes-container">
        <Table stickyHeader size="small" aria-label="Matryca modeli" className="attributes-table">
          <TableHead>
            <TableRow>
              <TableCell className="attr-head-cell" style={{minWidth: 120}}/>
              {headerCell("id", "Id", {minWidth: 70})}
              {headerCell("brand", "Marka", {options: brandOptions, minWidth: 150})}
              {headerCell("model", "Model", {minWidth: 150})}
              {headerCell("modelCode", "Model_code", {minWidth: 120})}
              {headerCell("bodyType", "Typ nadwozia - vehis", {minWidth: 160})}
              {headerCell("classType", "Klasa", {options: classList, minWidth: 150})}
              {headerCell("segment", "Segment", {options: segmentList, minWidth: 190})}
              {headerCell("type", "Typ", {options: typeList, minWidth: 130})}
              {headerCell("premium", "Premium", {options: [{value: "yes", label: "TAK"}, {value: "no", label: "NIE"}], minWidth: 100})}
              {headerCell("length", "Długość", {minWidth: 90})}
              {headerCell("width", "Szerokość", {minWidth: 90})}
              {headerCell("height", "Wysokość", {minWidth: 90})}
              {headerCell("trunkCapacity", "Pojemność", {minWidth: 90})}
              {headerCell("internalBodyType", "Nadwozie go-auto", {options: internalBodyTypeList, minWidth: 170})}
              {headerCell("defaultDescription", "Domyślny opis", {minWidth: 220})}
              {headerCell("url", "Obraz", {sortable: false, minWidth: 100})}
            </TableRow>
          </TableHead>
          <TableBody>
            {
              visibleElements.map((el) => (
                <React.Fragment key={el.id}>
                  { (el.deleted || !el.created && !el.edited) &&
                    <TableRow hover key={el.id} className={"attr-row" + (el.deleted ? " attr-row-deleted" : "")} style={{backgroundColor: el.deleted ? calculateColor(el) : undefined}}>
                      <TableCell className="attr-actions">
                        <Tooltip title={el.deleted ? "Przywróć" : "Usuń"}><IconButton size="small" onClick={e => deleteRow(el.id)}><DeleteIcon fontSize="small"/></IconButton></Tooltip>
                        {!el.created && !el.edited && <Tooltip title="Edytuj"><IconButton size="small" onClick={e => editRow(el.id)}><EditIcon fontSize="small"/></IconButton></Tooltip>}
                        <Tooltip title="Kopiuj"><IconButton size="small" onClick={e => copyRow(el)}><CopyIcon fontSize="small"/></IconButton></Tooltip>
                        {duplicateInfo.issuesById.has(el.id) && (
                          <Tooltip title={duplicateInfo.issuesById.get(el.id).join("; ")}>
                            <WarningIcon fontSize="small" style={{color: "#ed6c02", verticalAlign: "middle", marginLeft: 4}}/>
                          </Tooltip>
                        )}
                      </TableCell>
                      <TableCell>{el.id} </TableCell>
                      <TableCell>{el.brand}</TableCell>
                      <TableCell>{el.model}</TableCell>
                      <TableCell>{el.modelCode}</TableCell>
                      <TableCell>{el.bodyType}</TableCell>
                      <TableCell>{el.classType}</TableCell>
                      <TableCell>{el.segment}</TableCell>
                      <TableCell>{el.type}</TableCell>
                      <TableCell>{el.premium ? "TAK" : "NIE"}</TableCell>
                      <TableCell>{el.length}</TableCell>
                      <TableCell>{el.width}</TableCell>
                      <TableCell>{el.height}</TableCell>
                      <TableCell>{el.trunkCapacity}</TableCell>
                      <TableCell>{el.internalBodyType}</TableCell>
                      <TableCell>{el.defaultDescription ? el.defaultDescription.split(' ').slice(0, 4).join(' ') + (el.defaultDescription.split(' ').length > 4 ? '...' : '') : ''}</TableCell>
                      <TableCell>
                        {el.url && <Button onClick={() => {
                          setOpenImagePreview(true);
                          setImagePreview(el.url);
                        }}><VisibilityIcon />
                        </Button>}
                        <Button onClick={() => {
                          setOpenImageUpload(true);
                          setIdForImage(el.id);
                        }}>
                          <FileUploadIcon />
                        </Button>
                      </TableCell>

                    </TableRow>
                  }
                  { !el.deleted && (el.edited || el.created) &&
                  <TableRow key={el.id} className={"attr-row " + (el.created ? "attr-row-created" : "attr-row-edited")}>
                    <TableCell className="attr-actions"><Tooltip title="Usuń"><IconButton size="small" onClick={e => deleteRow(el.id)}><DeleteIcon fontSize="small"/></IconButton></Tooltip></TableCell>
                    <TableCell>{el.id} </TableCell>
                    <TableCell><TextField defaultValue={el.brand} fullWidth onBlur={e => handleChange(e, el.id, "brand")} variant="outlined"/></TableCell>
                    <TableCell><TextField defaultValue={el.model} fullWidth onBlur={e => handleChange(e, el.id, "model")} variant="outlined"/></TableCell>
                    <TableCell><TextField defaultValue={el.modelCode} fullWidth onBlur={e => handleChange(e, el.id, "modelCode")} variant="outlined"/></TableCell>
                    <TableCell><TextField defaultValue={el.bodyType} fullWidth onBlur={e => handleChange(e, el.id, "bodyType")} variant="outlined"/></TableCell>
                    <TableCell><Select defaultValue={el.classType} fullWidth onChange={e => handleChange(e, el.id, "classType")} variant="outlined">
                      <MenuItem value={null}>Nie wybrano</MenuItem>
                      {classList.map((p) => <MenuItem value={p}>{p}</MenuItem>)}
                    </Select></TableCell>
                    <TableCell><Select defaultValue={el.segment} fullWidth onChange={e => handleChange(e, el.id, "segment")} variant="outlined">
                      <MenuItem value={null}>Nie wybrano</MenuItem>
                      {segmentList.map((p) => <MenuItem value={p}>{p}</MenuItem>)}
                    </Select></TableCell>
                    <TableCell><Select defaultValue={el.type} fullWidth onChange={e => handleChange(e, el.id, "type")} variant="outlined">
                      <MenuItem value={null}>Nie wybrano</MenuItem>
                      {typeList.map((p) => <MenuItem value={p}>{p}</MenuItem>)}
                    </Select></TableCell>
                    <TableCell><Checkbox checked={el.premium} fullWidth onChange={e => handleChange(e, el.id, "premium")} variant="outlined"/></TableCell>
                    <TableCell><TextField defaultValue={el.length} fullWidth onBlur={e => handleChange(e, el.id, "length")} variant="outlined"/></TableCell>
                    <TableCell><TextField defaultValue={el.width} fullWidth onBlur={e => handleChange(e, el.id, "width")} variant="outlined"/></TableCell>
                    <TableCell><TextField defaultValue={el.height} fullWidth onBlur={e => handleChange(e, el.id, "height")} variant="outlined"/></TableCell>
                    <TableCell><TextField defaultValue={el.trunkCapacity} fullWidth onBlur={e => handleChange(e, el.id, "trunkCapacity")} variant="outlined"/></TableCell>
                    <TableCell><Select defaultValue={el.internalBodyType} fullWidth onChange={e => handleChange(e, el.id, "internalBodyType")} variant="outlined">
                      <MenuItem value={null}>Nie wybrano</MenuItem>
                      {internalBodyTypeList.map((p) => <MenuItem value={p}>{p}</MenuItem>)}
                    </Select></TableCell>
                    <TableCell style={{minWidth: 250}}><TextField defaultValue={el.defaultDescription} fullWidth onBlur={e => handleChange(e, el.id, "defaultDescription")} variant="outlined" multiline inputProps={{style: {fontSize: '0.75rem'}}} InputProps={{style: {fontSize: '0.75rem', maxHeight: 100, overflowY: 'auto'}}}/></TableCell>
                    <TableCell>-</TableCell>
                  </TableRow>}

                </React.Fragment>
              ))
            }
          </TableBody>
        </Table>
      </TableContainer>
      <Dialog
      open={openImagePreview}
      >
        <DialogTitle id="alert-dialog-title" disableTypography={true}><Typography variant="h3" gutterBottom
                                                                                  style={{borderBottom: 'solid 1px'}}>
          Podgląd obrazu
        </Typography></DialogTitle>
        <DialogContent>
          <Box>
            <img
              src={imagePreview}
              alt="Preview"
              style={{ width: '800px', maxWidth: '100%' }} // Ensures responsive width
            />
          </Box>

          <Button onClick={()=>setOpenImagePreview(false)} variant="contained" style={{marginRight: 10}}>
            Zamknij
          </Button>
        </DialogContent>
      </Dialog>
      <Dialog
        open={openImageUpload}
      ><DialogTitle id="alert-dialog-title" disableTypography={true}><Typography variant="h3" gutterBottom
                                                                                 style={{borderBottom: 'solid 1px'}}>
        Wczytaj obraz
      </Typography></DialogTitle>
        <DialogContent>
          <Box
            style={{ width: '800px', maxWidth: '100%' }} // Ensures responsive width
          >
            <DropzoneArea
              acceptedFiles={['image/*']}
              onChange={(file) => {
                setUploadedImage(file[0]);
                console.log(file[0])
              }}
              showFileNames={false}
              dropzoneText="Kliknij lub przeciągnij zdjęcia"
              showAlerts={true}
              filesLimit={1}
              maxFileSize={5000000}
            />
          </Box>
          <Button onClick={handleUpload} variant="contained" style={{ marginRight: 10 }}>
          Zapisz
          </Button>
          <Button onClick={()=>setOpenImageUpload(false)} variant="contained" style={{marginRight: 10}}>
            Zamknij
          </Button>
        </DialogContent>
      </Dialog>
    </div>
  )
}

export default AttributesList;
